var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"none"}},[_c('div',{staticClass:"top-box whiteBg"},[_c('search-input',{attrs:{"placeholder":'请输入要搜索的服务网点名称'},on:{"search":_vm.handleSearch}})],1),_c('div',[_c('site-details',{ref:"siteDetail",attrs:{"cilentHeight":_vm.cilentHeight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }